import { TripViewModel } from '@wegoTypes/flights/tripViewModel';

export enum SliderFiltersUniqueForEachLeg {
  ArrivalTimeFilter = 'arrivalTimes',
  DepartueTimeFilter = 'departureTimes',
  TotalDurationFilter = 'durations',
}

export type DepartLegGroup = {
  departLegId: string | number;
  tripViewModels: Array<TripViewModel>;
};

export type GenzoTrackApplyFilterActionEventType = (
  eventDataObjectType: string,
  eventDataActionType: string,
  eventDataPair: { [key: string]: any },
) => void;
